import e, { useState as u, useEffect as d } from "react";
import f from "classnames";
import s from "./index19.mjs";
import { Overlay as p } from "./index20.mjs";
const w = ({
  isShow: t,
  onClose: c,
  children: m
}) => {
  const o = e.useRef(), [r, n] = u(!1), [l, a] = u(!1);
  d(() => {
    a(!0);
  }, []), d(() => {
    if (!t) {
      document.body.removeAttribute("style");
      return;
    }
    return o.current = setTimeout(() => {
      n(!0);
    }, 10), document.body.style.overflow = "hidden", () => {
      clearTimeout(o.current);
    };
  }, [t]);
  const i = () => {
    n(!1), c();
  };
  return t ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "side-panel",
      className: f(s.container, {
        [s.show]: r,
        [s.show_expanded]: l
      })
    },
    r ? m({
      onClose: i,
      setIsExpanded: a,
      isExpanded: l
    }) : null
  ), /* @__PURE__ */ e.createElement(p, { isShow: r })) : null;
};
export {
  w as SidePanel
};
